import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiV6Service } from '@service/apiv6.service';
import { TreeService } from '@service/tree.service';
import { from, lastValueFrom, of, catchError, map} from 'rxjs';
import { forkJoin } from 'rxjs';
import { Tools } from '@service/tools';
import { TreeNode } from 'primeng/api';
import { MessagesService } from '@core/_services/messages.service';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { DisplayResultComponent } from '@documalis/displayresult';
import { TreeSearchRequestComponent } from '@documalis/treesearchrequest';
import { doc_name, doc_creationdate, doc_page, reqTre, doc_atfcount, KeyDetailDocks } from '@documalis/_const/const';
import { ParamUrlService } from '@service/paramurl.service';
import {
    setinfoList,
    currentRequest,
    encodeUtf8,
    setCurrentRequest,
    getlistColumns,
    setResulProperty,
    findItem,
} from '@core/_utils/tools.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'page-tree-search',
    templateUrl: './page-tree-search.component.html',
    styleUrls: ['./page-tree-search.component.scss'],
})
export class PageTreeSearchComponent implements OnInit {
    public srchMode = reqTre;
    public requests = [];
    public resultRequest: any;
    public resultDisplay: any;
    public resultList: any[];
    public curPage: number;
    public nbDoc: number;
    public error = false;
    public listColumns: any[];
    public treeIndex;
    public resultTree;
    public index: number;
    public searchPath = '';
    public selectedFile: TreeNode; //[] = [];
    public errorMessage = '';
    public displayCriteria = false;
    public displayListResult = false;
    public displaySearch = false;
    public displaySearchQuery = false;
    public updatePath = '';
    public testPath = '';
    public infoList: any[];
    public currentRequest: currentRequest;
    public isDesktop: boolean = false;
    public test = '';
    public displayRes: boolean = false;   
    public fetchParam: any;	
    public blockedTree: boolean = false;
    public filterState: {
        state: boolean;
        message: string;
    };
    public allowFullText: boolean = false;

    @ViewChild('dispresult') public dispResult: DisplayResultComponent;
    @ViewChild('treerequest') public treeRequest: TreeSearchRequestComponent;

    constructor(
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private tools: Tools,
        public menu: MenuServiceInt,
        private treeService: TreeService,
        private paramUrlService: ParamUrlService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
        this.setResultList();
        this.infoList = [];
        this.infoList = setinfoList(this.resultList);
        this.fetchParam = {page: 1, displayNext: false};
    }

    ngOnInit() {
        this.index = 0;
        this.displayRes = false;
        return from(this.menu.getMenu()).pipe(
            map(result => {
                this.allowFullText = this.menu.allowFullText;
                this.getRequestData();
                this.commonService.checkReset();        
             }),
            catchError((error: any) => {
                console.log(error);
                return of(null);
            })).subscribe();
    }

    public ngOnDestroy() {
        this.fetchParam = null;
    }

    private async getRequestData() {
        let wRes: any;
        this.treeService.init();                 
        try {
            wRes = await lastValueFrom(this.readAll());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }         
        if (wRes.getRootList.base === undefined) {
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        if (wRes.getRootList.base.result === '') {
            this._messageService.addErrorMsg(this.translate.instant('No_Result'));
            return;        
        }
        this.resultTree = wRes.getRootList.base.result;
        this.requests = wRes.getRequestList.data.map((item) => {
            item.searchPath = item.searchpath;
            return item;
        });
        this.tools.setDocks(KeyDetailDocks, wRes.getDocks, '');        
        this.treeIndex = this.treeService.updateTreeSearch(this.resultTree);
        if (this.paramUrlService.tree === true) {
            this.menu.updateRestrited(this.paramUrlService.restricted);
            this.execAuto();
        }
    }

    private readAll() {
        return forkJoin([
            this.getRootList(), 
            this.getRequestList(),
            this.getDocks(), 
        ]).pipe(
            map(([getRootList, getRequestList, getDocks]) => {
                return { getRootList, getRequestList, getDocks };
            })
        );
    }

    private getRootList() {
        if (this.paramUrlService.trunctree === true) {
            return this.getRootListV5();
        } else {
            return this.getRootListV6();
        }
    }

    private getRootListV5() {
        if (this.paramUrlService.tree === true && 
            (this.paramUrlService.root !== '' && this.paramUrlService.path !== ''))  {
            return this.api.getRootPath(false, {
                root: this.paramUrlService.root,
                path: this.paramUrlService.path,
                filterTree: this.paramUrlService.getFilter()
            }, false);
        } else {
            return this.api.getRootPath(false, null, false);
        }
    }

    private getRootListV6() {
        if (this.paramUrlService.tree === true && 
            (this.paramUrlService.root !== '' && this.paramUrlService.path !== '' &&
            this.paramUrlService.fromDash === false))  {
            return this.api.getChildRoot(false, {
                root: this.paramUrlService.root,
                path: this.paramUrlService.path,
                filterTree: this.paramUrlService.getFilter()
            }, false);
        } else {
            return this.api.getRootList(false, null, true);
        }
    }

    private getRequestList() {
        return this.api.execUrlAction('gettreesearch','');
    }

    private getDocks() {
        return this.api.execUrlAction('getdocksbasket',{name: KeyDetailDocks});
    }

    public addRequest() {
        this.treeRequest.addRequest();
    }

    public nodeSelect(event) {
        this.treeService.execAuto = false;
        this.searchPath = this.treeService.getPathClick(event.node, '');
        this.execTreeSearch(this.searchPath);
    }

    public async nodeExpand(event) {
        let wRes;
        if (this.paramUrlService.trunctree === true) {
            return;
        }
        wRes = await this.treeService.nodeExpand(event, (callBack) => {
            this.blockedTree = callBack;
        });
    }    
    
    private execTreeSearch(aPath) {
        this.treeService.path = aPath;
        aPath = this.completePath(aPath);
        this.updatePath = aPath;
        this.searchPath = encodeUtf8(aPath);
        this.testPath = '';
        this.getTreeSearch(this.searchPath, '');
    }

    private completePath(aPath) {
        if (this.treeService.execAuto === false && this.treeService.filterTree !== '') {
            return this.treeService.root + '/' + this.treeService.filterTree + '/' + aPath;
        } else {
            return aPath
        }
    }

    public onFilterSearch() {
        this.displaySearch = true;
    }

    public closeSearch() {
        this.displaySearch = false;
    }

    public onClickSearch($event) {
        this.displaySearch = false;
        this.getTreeSearch(this.searchPath, $event.searchText);
    }

    private execAuto() {
        if (this.verifyParamUrl() === true) {
            this.treeService.execAuto = true;
            this.treeService.root = this.paramUrlService.root;
            this.treeService.path = this.paramUrlService.path;
            if (this.paramUrlService.trunctree === true) {
                this.treeService.filterTree = this.paramUrlService.filtertree;
            }
            this.setRequestPath(this.paramUrlService.root + this.paramUrlService.path);
            this.execTreeSearch(this.searchPath);
        } else {
            this.index = -1;
            this._messageService.addErrorNoStick(this.translate.instant('Path_Sel_2'));
        }
        this.paramUrlService.clear();
    }

    private verifyParamUrl() {
        if (this.paramUrlService.filtertree !== '') {
            return true;
        } else {
            if (
                findItem(this.treeIndex, this.paramUrlService.root, 'label') === -1 ||
                this.paramUrlService.root === '' ||
                this.paramUrlService.path === ''
            ) {
                return false;
            } else {
                return true;
            }
        }

    }

    public selectRequest($event) {
        this.setRequestPath($event.searchPath.trim());
    }

    private async setRequestPath(aPath) {
        let wRootPath: any = {}
        let wPath = aPath;
        this.treeService.openPath = wPath;
        if (this.treeService.openPath.length !== 0) {
            this.testPath = this.treeService.openPath;
            this.index = 0;
            this.searchPath = this.treeService.updateSearchPath();
            this.updatePath = this.searchPath;
            // Pas de chargement de la racine (flux issu de la V5)
            if (this.paramUrlService.trunctree === true) {
                return;
            }
            wRootPath = this.treeService.getRootPath(this.searchPath);
            if (this.treeService.rootIsPresent(wRootPath.root, this.treeIndex) === false) {
                this._messageService.addErrorNoStick(this.translate.instant('No_TreeExist'));
                return;
            }
            await this.treeService.loadRoot(wRootPath.root, this.treeIndex, (callBack) => {
                this.blockedTree = callBack;
            });
            if (this.treeService.loadRootFailed === false) {
                this.treeIndex = this.treeService.initTree(this.treeIndex);
                this.treeIndex = this.treeService.updateFromPath(this.treeIndex);
                this.selectedFile = this.treeService.lastNode;
            }
        } else {
            this._messageService.addErrorNoStick(this.translate.instant('Path_Sel_1'));
        }
    }

    public async getTreeSearch(apath, aSearchWord) {
        let wRes: any;
        let wCheck: any;
        this.init();
        this.displayListResult = false;
        const wParams = this.treeService.formatRequestTree(apath, null, null, false, aSearchWord);
        this.currentRequest = setCurrentRequest(reqTre, wParams);
        this.listColumns = getlistColumns(this.resultList, this.translate);
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('exectreesearch', wParams));
            wCheck = this.tools.checkResult(wRes, reqTre, this.translate.instant('Find_0'));
            if (wCheck.success === false || wCheck.index === 0) {
                return;
            }    
            this.resultRequest = wCheck.resultRequest;
            this.resultDisplay = this.tools.formatDisplayDate(wCheck.resultDisplay, this.listColumns);
            this.curPage = wCheck.curPage;
            this.nbDoc = wCheck.nbDoc;
            this.filterState = this.tools.getFilterState(wCheck.nbDoc, aSearchWord);
            this.displayRes = this.nbDoc !== 0;
            this.displayCriteria = wCheck.displayCriteria;                
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }               
    }

    // private updateTreeSearch(aData) {
    //     if (aData !== undefined) {
    //         this.treeIndex = this.treeService.getTree(aData);
    //         // this.createPath(this.treeIndex,'');
    //     }
    // }

    private createPath(tree, path) {
        return tree.map((node) => {
            let children;
            let currentPath = '';
            if (path !== '') {
                currentPath = `${path}\\${node.label}`;
            } else {
                currentPath = `${node.label}`;
            }
            if (node.children) {
                children = this.createPath(node.children, currentPath);
            }
            node.selpath = currentPath;
            return {
                ...node,
            };
        });
    }

    public returnCriteria() {
        this.index = 0;
        this.displayCriteria = false;
        this.displayListResult = false;
    }

    public returnList() {
        this.index = 0;
        this.displayListResult = false;
        this.dispResult.goResultDoc();
    }

    public onReturnResult(event) {
        this.index = 1;
        this.displayListResult = true;
    }

    public onAction(event) {
        if (event === 'move') {
            this.returnList();
        }
    }

    public onNextDocs() {}

    public searchQuery() {
        this.displaySearchQuery = true;
    }

    public closeRequest(event) {
        this.displaySearchQuery = event;
    }

    private init() {
        this.resultDisplay = null;
        this.listColumns = null;
        this.nbDoc = 0;
        this.index = 0;
        this.displayRes = false;
    }

    private setResultList() {
        this.resultList = [];
        this.resultList.push(doc_atfcount);
        this.resultList.push(doc_name);
        this.resultList.push(doc_creationdate);
        this.resultList.push(doc_page);
        setResulProperty(this.resultList, doc_name.name, 'thumbinfo', 1);
    }
}
